<!-- 比赛倒计时页面 -->
<template>
<div class="content">
    <img :src="imageUrl" class="image-url" v-if="imageUrl"/>
    <div id="draggable2" class="wrap">        
        <el-button  type="primary"  @click="handlePlayStart" v-if="isShow">开始</el-button>   
        <el-button  @click="handlePlayEnd"    v-else>停止</el-button>    
        <el-button  @click="handleRest">重置</el-button>
    </div>   
    <div class="count" >
        <span class="timer"  id="draggable"
        :style="{color: colorValue, fontSize: textSize + 'px'}">{{ countTime }} </span>
    </div>  
</div>
</template>
<script>
import countDownBg from '@/assets/images/countdown.png'
export default {
    data() {
        return {
            isFull: false,
            publishId: '',
            countdownTimer: null,
            minute: 50,
            countTime: null,
            isShow: false,
            flag: 1,
            errorMsg: '',
            minuteSet: 0,
            secondSet: 0,
            imageUrl: '',
            textSize: '200',
            colorValue: '#fff',
            active: false,
            currentX: '',
            currentY: '',
            initialX: '',
            xOffset: 0,
            yOffset: 0,
            active2: false,
            currentX2: '',
            currentY2: '',
            initialX2: '',
            xOffset2: 0,
            yOffset2: 0,
            pubType: '1',
            imageUrlBg: countDownBg
        }
    },
    created() {        
        this.publishId = this.$route.query.id
        setTimeout(()=>{
            this.getTimeQuery()
        },300)    
        document.addEventListener('click', this.toggleFullScreen);    
        // console.log('created')
    },
    mounted() { 
        // console.log('muounted')        
        const draggable = document.getElementById('draggable');        
        draggable.addEventListener('mousedown', this.dragStart, false);       
        document.addEventListener('mouseup', this.dragEnd, false);
        document.addEventListener('mousemove', this.drag, false);

        const draggable2 = document.getElementById('draggable2')
        draggable2.addEventListener('mousedown', this.dragStart2, false);
        document.addEventListener('mouseup', this.dragEnd2, false);
        document.addEventListener('mousemove', this.drag2, false);

        // 在组件挂载后添加事件监听器
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    methods: {
        handleVisibilityChange() {
            if (document.hidden) {
                // console.log('页面不可见');
                // 执行页面不可见时的逻辑
                clearInterval(this.countdownTimer);
                
            } else {
                // console.log('页面可见');
                // 执行页面可见时的逻辑
                this.getTimeQuery()
            }
        },
        handlePlayStart(e){
            e.stopPropagation();            
            this.flag = 1
            clearInterval(this.countdownTimer);  
            this.isShow = !this.isShow
            if(this.flag){
                this.submit()
            }
        },
        handlePlayEnd(e){
            e.stopPropagation();
            this.flag = 2
            this.isShow = !this.isShow
            clearInterval(this.countdownTimer);
            if(this.flag){
                this.submit()
            }
        },
        handleRest(e){
            e.stopPropagation();
            this.flag = 3
            clearInterval(this.countdownTimer);
            this.isShow = true
            if(this.flag){
                this.submit()
            }
        },
        getCountdown(){            
            var remainingTime = Number(this.minuteSet) * 60 + Number(this.secondSet); // 30分钟，以秒为单位
            
            this.countdownTimer = setInterval(()=> {
                var minutes = Math.floor(remainingTime / 60);
                var seconds = remainingTime % 60;
                // console.log(remainingTime,minutes,seconds)
                if(remainingTime === 180){
                    // 倒计时3分钟调整到成绩公示大屏页面 
                    this.$router.push({
                        path: 'fullScoreRefresh',
                        query:{
                            id: this.publishId
                        }
                    })
                }
                // 在页面上更新倒计时显示 (minutes < 10 ?'0' + minutes :minutes)
                this.countTime =(minutes < 10 ?'0' + minutes :minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
                // console.log(this.countTime)
                if (remainingTime > 0) {
                    remainingTime--;
                } else {
                    clearInterval(this.countdownTimer); // 当倒计时结束时清除定时器
                }
            }, 1000); // 每隔一秒更新一次
        },          
        submit(){
            let params  = {
                opcode: this.$code.CountDownSet,
                i_serial_mark: this.publishId,
                timer: this.minute,
                i_timer: 0,
                // 1：开始；2：停止；3：复位；
                i_flag: this.flag,
                // i_image: this.imageUrl,
                // i_typeface: this.textSize,
                // i_colour: this.colorValue
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.getTimeQuery()
                }
            })
        },
        getTimeQuery(){
            clearInterval(this.countdownTimer);
            let params = {
                opcode: this.$code.TimerQuery,
                i_serial_mark: this.publishId,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let list = res.Data.DataTable
                    let result = list.map(i=>{
                        return{
                            t: i['倒计时'],
                            remain: i['剩余倒计时'],
                            status: i['状态'],
                            img: i['图片'],
                            size: i['字体'],
                            color: i['颜色'],
                        }
                    })
                    this.imageUrl = result[0].img ? result[0].img : this.imageUrlBg 
                    this.textSize = result[0].size
                    this.colorValue = result[0].color || '#fff'
                    // console.log("图片链接",this.imageUrl,this.colorValue)
                    let arr = result[0].t
                    let arr2 = arr.split(':')
                    // console.log(arr2)
                    if(Number(arr2[0]) > 0){
                        this.minuteSet = arr2[0]
                        this.secondSet = arr2[1]
                    }                    
                    this.countTime = result[0].t   
                    if(result[0].status === '开始'){
                        this.isShow = false
                        this.getCountdown()  
                    }     
                    if(result[0].status === '暂停' || result[0].status === '结束'){
                        this.isShow = true
                        clearInterval(this.countdownTimer)
                    }      
                }else{
                    this.errorMsg = res.Message
                    this.imageUrl = this.imageUrlBg
                    clearInterval(this.countdownTimer)
                }
            })
        },  
        toggleFullScreen(){
            if (!document.fullscreenElement) {
                this.$help.enterFullScreen();
            } else {
                this.$help.exitFullScreen();
            }            
        },  
        dragStart(e){
            e.stopPropagation();
            const draggable = document.getElementById('draggable');
            this.initialX = e.clientX - this.xOffset;
            this.initialY = e.clientY - this.yOffset;
        
            if (e.target === draggable) {
                this.active = true;
            }
        },        
        dragEnd(e){
            this.initialX = this.currentX;
            this.initialY = this.currentY;        
            this.active = false;
        },
        drag(e){
            const draggable = document.getElementById('draggable');
            if (this.active) {
                e.preventDefault();
            
                this.currentX = e.clientX - this.initialX;
                this.currentY = e.clientY - this.initialY;
            
                this.xOffset = this.currentX;
                this.yOffset = this.currentY;
            
                this.setTranslate(this.currentX, this.currentY, draggable);
            }
        },
        dragStart2(e){
            e.stopPropagation();
            const draggable2 = document.getElementById('draggable2');
            this.initialX2 = e.clientX - this.xOffset2;
            this.initialY2 = e.clientY - this.yOffset2;
        
            if (e.target === draggable2) {
                this.active2 = true;
            }
        },        
        dragEnd2(e){
            this.initialX2 = this.currentX2;
            this.initialY2 = this.currentY2;        
            this.active2 = false;
        },
        drag2(e){
            const draggable2 = document.getElementById('draggable2');
            if (this.active2) {
            e.preventDefault();
        
            this.currentX2 = e.clientX - this.initialX2;
            this.currentY2 = e.clientY - this.initialY2;
        
            this.xOffset2 = this.currentX2;
            this.yOffset2 = this.currentY2;
        
            this.setTranslate(this.currentX2, this.currentY2, draggable2);
            }
        },
        setTranslate(xPos, yPos, el) {
            el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
        }
    },
    beforeDestroy() {
        // 在实例销毁前移除事件监听
        document.removeEventListener('click', this.toggleFullScreen);
        document.removeEventListener('mousedown', this.dragStart);
        document.removeEventListener('mouseup', this.dragEnd);
        document.removeEventListener('mousemove', this.drag);

        document.removeEventListener('mousedown', this.dragStart2);
        document.removeEventListener('mouseup', this.dragEnd2);
        document.removeEventListener('mousemove', this.drag2);

        // 在组件销毁前移除事件监听器
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    destroyed(){
        clearInterval(this.countdownTimer)
    }    
}
</script>
<style lang='scss' scoped>
.content{
    width: 100%;
    height: 100vh;
    // display: flex;    
    // justify-content: center;
    // align-items: center;
    // flex-direction: column;
}
.count{
    margin: 50px 0;
    font-size: 28px;
    cursor: pointer;    
}
.timer{
    position: absolute;
    cursor: pointer;
    font-size: 200px;
    // margin-left: 30px;
    // top: 30%;
    // left: 35%;    
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);     
}
.image-url{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index:-1
}
.wrap{
    padding:30px;
    position: absolute;
    left: 20px;
    top:75%;
    opacity:0.3;
}
</style>


// WEBPACK FOOTER //
// src/views/fullScreen/fullCountdown.vue